import React from "react";
import styled from "styled-components";
import { HOME_SCREEN_CONTRIBUTORS } from "../../../constants";

const ImageGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: var(--global-spacing-l);
  gap: 32px;
`;

const ContributorLogo = styled.img`
  margin: 0 auto;
  display: block;
  height: 28px;
  @media screen and (max-width: 600px) {
    height: 24px;
  }
`;

const Contributors: React.FC = () => {
  return (
    <>
      <ImageGrid>
        {HOME_SCREEN_CONTRIBUTORS.map(({ imageSrc, text }) => (
          <div style={{ flexGrow: 1 }} key={text}>
            <ContributorLogo
              key={text}
              src={imageSrc}
              alt={text}
              title={text}
            />
          </div>
        ))}
      </ImageGrid>
      <div>
        Trusted and contributed to by great teams. Maintained and commercially
        supported by <a href="https://r2c.dev">r2c</a>.
      </div>
    </>
  );
};

export default Contributors;
